module.exports = __webpack_public_path__ + "img/angle-right.239b9721.svg";